import moment from 'moment';

export function getFormattedDuration(durationSecs, useShortFormsWithoutSpace) {
  // console.log('durationSecs', durationSecs);

  const dur = moment.duration(durationSecs, 'seconds');
  const hrs = Math.floor(dur.asHours());
  const mins = Math.floor(dur.asMinutes() % 60);
  const secs = Math.floor(dur.asSeconds() % 60);
  let retStr = '';
  // console.log('mins::', mins, secs);
  const hourString = useShortFormsWithoutSpace ? 'h ' : ' h ';
  const minString = useShortFormsWithoutSpace ? 'm ' : ' min ';
  const secString = useShortFormsWithoutSpace ? 's ' : ' sec ';
  if (hrs > 0) {
    retStr = retStr + hrs + hourString;
  }
  if (mins > 0 || hrs > 0) {
    retStr = retStr + mins + minString;
  }
  if (mins <= 0 && hrs <= 0 && useShortFormsWithoutSpace) {
    retStr = Math.ceil(durationSecs) + secString;
  } else if (mins <= 0 && hrs > 0 && useShortFormsWithoutSpace) {
    retStr = hrs + hourString + secs + secString;
  }
  return retStr;
}

export function getFormattedDuration1(durationSecs, useShortForms) {
  if (durationSecs == 0) {
    return '00:00 minutes';
  }
  const dur = moment.duration(durationSecs, 'seconds');
  const hrs = Math.floor(dur.asHours());
  let mins = Math.floor(dur.asMinutes() % 60);
  mins = mins < 9 ? '0' + mins : mins;
  let secs = Math.floor(dur.asSeconds() % 60);
  secs = secs < 9 ? '0' + secs : secs;
  let retStr = '';
  let unitString = ' hours';
  if (hrs > 0) {
    retStr = retStr + hrs + ':';
  }
  if (mins > 0) {
    if (hrs > 0) {
      retStr = retStr + mins + unitString;
      return retStr;
    }
    unitString = useShortForms ? ' min' : ' minutes';
    retStr = retStr + mins + ':';

    // retStr = retStr + mins + unitString;
  } else {
    retStr = retStr + mins + ':';
    unitString = useShortForms ? ' min' : ' minutes';
  }

  if (secs >= 0) {
    retStr = retStr + secs + unitString;
    return retStr;
  }
  return retStr;
}

export function getFomattedDueDate(dateString, shortMonth) {
  if (dateString == -1) {
    return 'Invalid date';
  }
  if (shortMonth === true) {
    return moment(dateString).format('Do MMM');
  }
  return moment(dateString).format('Do MMMM');
}

/**
 * [getTimeHHmm description]
 * @param  {[type]} dateString   Possible formats http://momentjs.com/docs/#/displaying/format/
 */
export function getTimeHHmm(dateString, formatString) {
  if (dateString == -1 || dateString == '' || !dateString) {
    return '';
  }
  if (formatString) {
    return moment(dateString).format(formatString);
  }
  return moment(dateString).format('HH:mm');
}

export function getElapsedTime(dateString) {
  if (!moment(dateString).isValid()) {
    console.log('Invalid Date');
    return '';
  }
  return moment(dateString).fromNow();
}
